import { Injectable } from '@angular/core';

import _configSettings from './../../../assets/edesignconfig.json';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly config: Record<string, any>;
  public imagePath = '/assets/images/';
  constructor() {
    this.config = _configSettings;
  }

  getConfiguration() {
    return this.config;
  }

  getUrlsObject() {
    return this.config.urlSettings;
  }

  getProductSelectorLink() {
    return environment.ProductSelector.productSelectorListing;
  }

  getProductImageUrl() {
    return environment.ProductSelector.productImage;
  }

  getProductImageBackupUrl() {
    return environment.ProductSelector.productImageBackup;
  }

  public getUrl(..._args) {
    let baseUrl = environment.apiEndpoint + '/' + environment.version;

    // eslint-disable-next-line prefer-rest-params
    for (const argument of arguments) {
      baseUrl += '/' + argument;
    }

    return baseUrl;
  }
}
